// export interface CardData {
//   // Basic Info
//   companyLogo: string;
//   companyName: string;
//   name: string;
//   designation: string;

//   // Contact Info
//   phone: string;
//   email: string;
//   address: string;

//   // Action Links
//   whatsappLink: string;
//   callLink: string;
//   locationLink: string;
//   websiteUrl: string;

//   // Media
//   image1: string;
//   image2: string;
//   video1: string;
//   video2: string;

//   // Social Media
//   facebook: string;
//   linkedin: string;
//   instagram: string;
//   twitter: string;
//   telegram: string;
// }


export const defaultCardData = {
  themeId: '',
  companyName: '',
  image: '',
  name: '',
  designation: '',
  phoneNumber: '',
  email: '',
  address: '',
  location: '',
  whatsappChat: '',
  call: '',
  facebookUrl: '',
  linkedinUrl: '',
  instagramUrl: '',
  twitterUrl: '',
  telegramUrl: '',
  pdf: '',
  ppt: '',
  videoUrl1: '',
  videoUrl2: '',
  website: '',
  websiteUrl: '',
  showExtraInputs: false,
  extraField1: '',
  extraField2: '',
  extraField3: '',
};
